module.exports = __webpack_public_path__ + "static/media/nextgenerationeu-vlaanderen-gefinancierd-door-de-eu-horizontal.a816738b.png";